export enum Errors {
  EmailDoesNotMatchAllowedDomains = 'User email does not match the domain zone',
}
